import { Checkbox, CheckboxProps, FormControlLabel, FormControlLabelProps } from '@mui/material';
import { FieldValues, useController, UseControllerProps } from 'react-hook-form';

interface CheckboxFormFieldProps extends Omit<FormControlLabelProps, 'control' | 'name'> {
  checkboxProps?: CheckboxProps;
}

export function CheckboxFormField<T extends FieldValues>({
  name,
  control,
  label,
  checkboxProps,
  ...formControlProps
}: UseControllerProps<T> & CheckboxFormFieldProps) {
  const {
    field: { value, onChange, ref },
  } = useController({
    name,
    control,
  });

  return (
    <FormControlLabel
      data-testid={name}
      checked={!!value}
      inputRef={ref}
      onChange={onChange}
      control={<Checkbox {...checkboxProps} />}
      label={label}
      {...formControlProps}
    />
  );
}
